import React from 'react';
import './AlertBox.css';

interface AlertBoxProps {
  show: boolean;
  message: string | null;
  onClose: () => void;
  onConfirm?: () => void;
  type?: 'alert' | 'error';
  children?: React.ReactNode;
}

const AlertBox: React.FC<AlertBoxProps> = ({
  show,
  message,
  onClose,
  onConfirm,
  type = 'alert',
  children
}) => {
  if (!show || !message) return null;

  return (
    <div className="alert-overlay">
      <div className={`alert-box ${type}`}>
        <p>
            {message.split('\n').map((line, index) => (
                <span key={index}>
                {line}
                <br />
                </span>
            ))}
        </p>
        {children && <div className="alert-children">{children}</div>}
        <div className="alert-buttons">
          {onConfirm ? (
            <>
              <button onClick={onConfirm}>Yes</button>
              <button onClick={onClose}>No</button>
            </>
          ) : (
            <button onClick={onClose}>OK</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertBox;
